import { AchievementDefinition } from '../services/GameAPI';

export const FLAPPY_MUSE_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "flappy-muse-take-flight",
    gameId: "flappy-muse",
    title: "Muse Takes Flight",
    description: "Successfully calibrated your microphone to guide your Muse.",
    iconUrl: "🎤",
    museCashReward: 15,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "flappy-muse-first-pass",
    gameId: "flappy-muse",
    title: "First Pass",
    description: "Successfully passed your first pipe.",
    iconUrl: "✅",
    museCashReward: 10,
    type: "progression",
    rarity: "common",
    implemented: true,
    sortOrder: 2,
    category: "progression"
  },
  {
    id: "flappy-muse-whisperwind",
    gameId: "flappy-muse",
    title: "Whisperwind Navigator",
    description: "Successfully navigated through a pianissimo (pp) opening.",
    iconUrl: "🤫",
    museCashReward: 40,
    type: "skill",
    rarity: "rare",
    implemented: true,
    sortOrder: 3,
    category: "skill"
  },
  {
    id: "flappy-muse-thunder-rider",
    gameId: "flappy-muse",
    title: "Thunder-Rider",
    description: "Successfully navigated through a fortissimo (ff) opening.",
    iconUrl: "🗣️",
    museCashReward: 40,
    type: "skill",
    rarity: "rare",
    implemented: true,
    sortOrder: 4,
    category: "skill"
  },
  {
    id: "flappy-muse-streak-5",
    gameId: "flappy-muse",
    title: "Flawless Flow",
    description: "Successfully passed 5 pipes in a row without crashing.",
    iconUrl: "🔥",
    museCashReward: 75,
    type: "skill",
    rarity: "epic",
    implemented: true,
    sortOrder: 5,
    category: "skill"
  },
  {
    id: "flappy-muse-score-1k",
    gameId: "flappy-muse",
    title: "Budding Virtuoso",
    description: "Reached a score of 1,000 points.",
    iconUrl: "📈",
    museCashReward: 50,
    type: "progression",
    rarity: "rare",
    implemented: true,
    sortOrder: 6,
    category: "progression"
  },
  {
    id: "flappy-muse-survive-90s",
    gameId: "flappy-muse",
    title: "Aerial Ace",
    description: "Survived for 90 seconds in a single run.",
    iconUrl: "⏱️",
    museCashReward: 100,
    type: "skill",
    rarity: "epic",
    implemented: true,
    sortOrder: 7,
    category: "skill"
  },
  {
    id: "flappy-muse-score-3k",
    gameId: "flappy-muse",
    title: "Muse Maestro",
    description: "Reached an impressive score of 3,000 points.",
    iconUrl: "🌟",
    museCashReward: 150,
    type: "progression",
    rarity: "epic",
    implemented: true,
    sortOrder: 8,
    category: "progression"
  },
   {
    id: "flappy-muse-best-dressed",
    gameId: "flappy-muse",
    title: "Best Dressed",
    description: "Played a round with a custom Muse equipped.",
    iconUrl: "👩‍🎤",
    museCashReward: 20,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 9,
    category: "progression"
  },
  {
    id: "flappy-muse-a-minor-setback",
    gameId: "flappy-muse",
    title: "A Minor Setback",
    description: "Crashed for the first time. The journey of a thousand notes begins with a single... splat.",
    iconUrl: "💥",
    museCashReward: 5,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 10,
    category: "progression"
  }
]; 